import { render } from "./ApiKeyDocs.vue?vue&type=template&id=0cef65f0&scoped=true"
import script from "./ApiKeyDocs.vue?vue&type=script&lang=js"
export * from "./ApiKeyDocs.vue?vue&type=script&lang=js"

import "./ApiKeyDocs.vue?vue&type=style&index=0&id=0cef65f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cef65f0"]])

export default __exports__